import React from 'react';
import { CheckCircle, Warning, Error, Info, Close } from '@material-ui/icons';

export type AlertVariant = 'success' | 'warning' | 'danger' | 'info';

export interface AlertProps {
  variant: AlertVariant;
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const variantConfig = {
  success: {
    backgroundColor: '#EAF6EC',
    iconColor: '#4A9464',
    titleColor: '#4A9464',
    icon: CheckCircle
  },
  warning: {
    backgroundColor: '#FBF6E7',
    iconColor: '#D4A60D',
    titleColor: '#D4A60D',
    icon: Warning
  },
  danger: {
    backgroundColor: '#F6EAE6',
    iconColor: '#A72C09',
    titleColor: '#A72C09',
    icon: Error
  },
  info: {
    backgroundColor: '#EDF6FA',
    iconColor: '#48A4C8',
    titleColor: '#48A4C8',
    icon: Info
  }
};

export const Alert = ({ variant, title, children, onClose, className, style }: AlertProps) => {
  const config = variantConfig[variant];
  const IconComponent = config.icon;

  return (
    <div
      className={className}
      style={{
        backgroundColor: config.backgroundColor,
        borderRadius: '8px',
        padding: '16px',
        ...style
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px'
        }}
      >
        <div
          style={{
            paddingTop: '1px',
            flexShrink: 0
          }}
        >
          <IconComponent style={{ fontSize: 16, color: config.iconColor }} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            flex: 1
          }}
        >
          {title && (
            <div
              style={{
                fontFamily: "'Noto Sans JP', sans-serif",
                fontWeight: 700,
                fontSize: '13px',
                lineHeight: 1.5,
                color: config.titleColor
              }}
            >
              {title}
            </div>
          )}
          <div
            style={{
              fontFamily: "'Noto Sans JP', sans-serif",
              fontWeight: 400,
              fontSize: '11px',
              lineHeight: 1.5,
              color: '#3A3A3A'
            }}
          >
            {children}
          </div>
        </div>
        {onClose && (
          <button
            type="button"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              flexShrink: 0
            }}
            onClick={onClose}
          >
            <Close style={{ fontSize: 16, color: '#666666' }} />
          </button>
        )}
      </div>
    </div>
  );
};
